import axios from 'axios';
import { toast } from 'react-toastify';
import { push } from 'connected-react-router';

// URIs
import serverURI from 'config/URI';
// Helpers
import errorHandler from '../helpers/errorHandler';

//import { getParties } from './party';

export const ADDING_CATEGORY = () => ({ type: 'ADDING_CATEGORY', });
export const ADDING_CATEGORY_SUCCESS = () => ({ type: 'ADDING_CATEGORY_SUCCESS', });
export const ADDING_CATEGORY_ERROR = () => ({ type: 'ADDING_CATEGORY_ERROR', });

export const UPDATING_CATEGORY = () => ({ type: 'UPDATING_CATEGORY', });
export const UPDATING_CATEGORY_SUCCESS = () => ({ type: 'UPDATING_CATEGORY_SUCCESS', });
export const UPDATING_CATEGORY_ERROR = () => ({ type: 'UPDATING_CATEGORY_ERROR', });

export const LOADING_CATEGORIES = () => ({ type: 'LOADING_CATEGORIES', });
export const LOADING_CATEGORIES_SUCCESS = () => ({ type: 'LOADING_CATEGORIES_SUCCESS', });
export const LOADING_CATEGORIES_ERROR = () => ({ type: 'LOADING_CATEGORIES_ERROR', });

export const DELETING_CATEGORY = () => ({ type: 'DELETING_CATEGORY', });
export const DELETING_CATEGORY_SUCCESS = () => ({ type: 'DELETING_CATEGORY_SUCCESS', });
export const DELETING_CATEGORY_ERROR = () => ({ type: 'DELETING_CATEGORY_ERROR', });

export const UPDATING_CATEGORY_ORDER = () => ({ type: 'UPDATING_CATEGORY_ORDER', });
export const UPDATING_CATEGORY_ORDER_SUCCESS = () => ({ type: 'UPDATING_CATEGORY_ORDER_SUCCESS', });
export const UPDATING_CATEGORY_ORDER_ERROR = () => ({ type: 'UPDATING_CATEGORY_ORDER_ERROR', });

//export const UPDATING_CATEGORY_CHECKS = () => ({ type: 'UPDATING_CATEGORY_CHECKS', });


export const addCategory = (category, dispatch) => {
  dispatch({ type: ADDING_CATEGORY });

  axios
    .post(`${serverURI}/api/advertise/category/add`, category)
    .then((res) => {
      dispatch({ type: ADDING_CATEGORY_SUCCESS, 
        payload: res.data.category, 
        });
    })
    .catch((err) => {
      dispatch({ type: ADDING_CATEGORY_ERROR, payload: err });
      errorHandler(err);
    });
};

export const updateCategory = (id, category, dispatch) => {
  dispatch({ type: UPDATING_CATEGORY });

  axios
    .put(`${serverURI}/api/advertise/category/update/${id}`, category)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_CATEGORY_SUCCESS, 
        payload: res.data.updated_category, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_CATEGORY_ERROR, payload: err });
      errorHandler(err);
    });
};

export const deleteCategory = (deletes, dispatch) => {
  dispatch({ type: DELETING_CATEGORY });

  const deleteData = {
    deletes: deletes,
  };

  return axios
    .delete(`${serverURI}/api/advertise/category/delete`, {data: deleteData})
    .then((res) => {
      //console.log(res);
      dispatch({ type: DELETING_CATEGORY_SUCCESS, 
        payload: res.data.deletedCategories, 
        });
    })
    .catch((err) => {
      dispatch({ type: DELETING_CATEGORY_ERROR, payload: err });
      errorHandler(err);
    });
};

export const getCategories = (dispatch) => {
  dispatch({ type: LOADING_CATEGORIES });

  axios
    .get(`${serverURI}/api/advertise/category/all`)
    .then((res) => {
      dispatch({
        type: LOADING_CATEGORIES_SUCCESS,
        payload: res.data.categories
      });
    })
    .catch((err) => {
      dispatch({ type: LOADING_CATEGORIES_ERROR, payload: err });
      errorHandler(err);
    });
};


export const updateCategoryOrder = (newOrderCategory, dispatch) => {
  dispatch({ type: UPDATING_CATEGORY_ORDER });

  axios
    .put(`${serverURI}/api/advertise/category/order/update`, newOrderCategory)
    .then((res) => {
      //console.log(res);
      dispatch({ type: UPDATING_CATEGORY_ORDER_SUCCESS, 
        payload: res.data.categories, 
        });
    })
    .catch((err) => {
      dispatch({ type: UPDATING_CATEGORY_ORDER_ERROR, payload: err });
      errorHandler(err);
    });
};
